
























import { Prop, Component, Vue } from "vue-property-decorator";

interface DropdownItem {
  name: string;
  value: any;
}

@Component({})
export default class VDropdown extends Vue {
  @Prop({ default: () => [] }) items!: DropdownItem[];
  @Prop({ default: false }) expanded!: boolean;

  shown = false;

  get currentExpanded() {
    return this.expanded || this.shown;
  }

  show() {
    this.shown = true;
    this.$emit("show", true);
  }

  hide() {
    this.shown = false;
    this.$emit("hide", false);
  }

  toggle() {
    if (this.currentExpanded) {
      this.hide();
    } else {
      this.show();
    }
  }

  private select(item: DropdownItem, index: number, event: MouseEvent) {
    this.$emit("select", item.value, item.name, index, event);
    this.hide();
  }
}
